<template>
  <div>
    <el-dialog
      :visible.sync="showWarningDialog"
      width="800px"
      center
      :close-on-click-modal="false"
      :show-close="false"
      :modal-append-to-body="true"
      append-to-body
      :z-index="1"
      data-qa="warning-delete-dialog"
    >
      <div slot="title" class="dialog-title">
        <icon glyph="warning" style="color: orange; padding-right: 5px" />
        {{ $t('DeletePopupWarning_Warning') }}
      </div>
      <div class="warning-message">
        <p class="warning-header">
          {{
            $t('DeletePopupWarning_Warning_Header_Dialog', {
              itemName: itemName,
              entityType: entityType
            })
          }}
        </p>

        <p class="warning-description">
          {{
            $t('DeletePopupWarning_Warning_Description_Dialog', {
              entityType: entityType
            })
          }}
        </p>

        <ul class="warning-list">
          <li v-for="(item, index) in warningItems" :key="index">{{ item }}</li>
        </ul>

        <p class="warning-important">
          <icon glyph="warning" style="color: orange; padding-right: 5px" />
          {{ $t('DeletePopupWarning_Warning_Undone_Dialog') }}
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="el-button el-button--primary"
          @click="onCancel"
          data-qa="warning-cancel-button"
        >
          {{ $t('Cancel') }}
        </el-button>
        <el-button
          type="button"
          class="el-button el-button--primary is-plain"
          @click="onProceed"
          data-qa="warning-delete-button"
        >
          {{ $t('DeletePopupWarning_Warning_Delete_Dialog') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showConfirmDialog"
      width="600px"
      center
      :close-on-click-modal="false"
      :show-close="false"
      :modal-append-to-body="true"
      append-to-body
      :z-index="1"
      data-qa="confirm-delete-dialog"
    >
      <div slot="title" class="dialog-title">
        <icon glyph="warning" style="color: red; padding-right: 5px" />
        {{ $t('DeletePopupWarning_Warning_Delete') }}
      </div>
      <div>
        <p class="warning-header">
          {{
            $t('DeletePopupWarning_Warning_Header_Confirm', {
              itemName: itemName,
              entityType: entityType
            })
          }}
        </p>
        <p class="warning-description">
          {{ $t('DeletePopupWarning_Warning_Description_Confirm')
          }}<strong>
            {{ $t('DeletePopupWarning_Warning_Undone_Confirm') }}
          </strong>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="el-button el-button--primary"
          @click="onCancel"
          data-qa="confirm-cancel-button"
          >{{ $t('DeletePopupWarning_Warning_Cancel') }}</el-button
        >
        <el-button
          type="button"
          class="el-button el-button--primary is-plain"
          @click="onConfirm"
          data-qa="confirm-delete-button"
        >
          {{ $t('DeletePopupWarning_Warning_Confirm_Delete') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DeletePopupWarning',
  props: {
    showWarningDialog: {
      type: Boolean,
      default: false
    },
    showConfirmDialog: {
      type: Boolean,
      default: false
    },
    entityType: {
      type: String,
      default: 'item'
    },
    itemName: {
      type: String,
      default: ''
    },
    warningItems: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
    onProceed() {
      this.$emit('proceed')
    },
    onConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.warning-important {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
}

.warning-message {
  margin: 0;
}

.warning-header {
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 600;
}

.warning-description {
  margin-bottom: 20px;
  line-height: 1.5;
}

.warning-list {
  margin: 0 0 20px 0;
  padding-left: 20px;
  max-height: 200px;
  overflow-y: auto;
}

.warning-list li {
  margin-bottom: 8px;
  line-height: 1.4;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.warning-list {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.warning-list li {
  margin-bottom: 8px;
}

.warning-important {
  font-weight: bold;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/modules/consent-manager/components/DeletePopupWarning.vue